<div class="mobile-header-container">
  <button
    class="mobile-menu-button"
    (click)="toggleMobileExpanded()">
    <fly-icon icon="mobile-menu"></fly-icon>
  </button>
  <a
    [href]="legacyUrl"
    class="mobile-logo-link">
    <img
      src="https://static.garmincdn.com/apps/fly/img/logos/garmin-flyadmin-logo.svg"
      alt="FlyAdmin Logo" />
  </a>
</div>

<header
  class="header-container"
  [class.mobile-expanded]="mobileExpanded()">
  <a
    [href]="legacyUrl"
    class="logo-link">
    <img
      src="https://static.garmincdn.com/apps/fly/img/logos/garmin-flyadmin-logo.svg"
      alt="FlyAdmin Logo" />
  </a>
  <nav class="nav-container">
    <a [href]="legacyUrl">Home</a>
    <a [href]="legacyUrl + '/users/'">Users</a>
    @if (showWarningsLink()) {
      <a [href]="legacyUrl + '/warnings/'">Warnings</a>
    }
    <a [href]="legacyUrl + '/tools/'">Tools</a>
  </nav>
  <fly-navigation
    [navContent]="navigationTree()"
    class="fala-nav"></fly-navigation>
  <div class="auth-container">
    @if (showAuthInfo()) {
      @if (username != null) {
        <span>{{ username }}</span>
        <div class="divider"></div>
      }
      <button
        class="sign-out-button"
        (click)="signOut()"
        >Sign Out</button
      >
    }
  </div>
</header>
